import React from 'react';
import LegalContentLayout from '../components/common/Legal/LegalContentLayout';

const Privacy = () => <LegalContentLayout contentKey="privacy" />;

export default Privacy;
